"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fill: "#0071BE",
  fillRule: "evenodd",
  d: "M10.647 9.098V4a7.8 7.8 0 0 0-3.385 1.44 8 8 0 0 0-2.39 2.831A8 8 0 0 0 4 11.945q0 2.944 1.886 5.205 2.125-1.041 3.442-3.222 1.319-2.181 1.318-4.83zm2.702 7.695a7.3 7.3 0 0 1-1.38-2.815q-.356 1.512-1.37 2.815a9.6 9.6 0 0 1-2.453 2.219A7.75 7.75 0 0 0 11.97 20a7.77 7.77 0 0 0 3.832-.988 9.6 9.6 0 0 1-2.453-2.219m3.392-11.352a8 8 0 0 1 2.39 2.831v.001A8 8 0 0 1 20 11.947q0 2.944-1.884 5.205-2.126-1.043-3.444-3.222T13.356 9.1V4q1.864.315 3.385 1.44",
  clipRule: "evenodd"
}), 'Renren');
